import { Autocomplete } from '@chiroup/components';
import { FormError } from '@chiroup/core';
import React from 'react';
import useDatabaseAutocomplete from '../../../hooks/useDatabaseAutocomplete';

type Props = {
  instanceKey: string;
  value: string;
  onChange: (value: string) => void;
  onEmptyOptions?: () => void;
  error?: FormError;
  searchRef?: React.RefObject<HTMLInputElement>;
  buttonRef?: React.RefObject<HTMLInputElement>;
  initialDisplayValue?: string;
  label?: string;
  className?: string;
  getInitialOptions?: boolean;
};

const DatabaseAutocomplete: React.FC<Props> = ({
  instanceKey,
  value,
  onChange,
  error,
  searchRef,
  buttonRef,
  onEmptyOptions,
  initialDisplayValue,
  label = '',
  className,
  getInitialOptions = false,
}) => {
  const {
    options,
    fetchNextPage,
    isFetching,
    // isPreloading,
    onChangeSearch,
    hasNextPage,
    search,
  } = useDatabaseAutocomplete(
    instanceKey,
    Number.parseInt(value),
    getInitialOptions,
  );

  const onSelect = (code: string) => {
    onChange(code);
  };

  return (
    <Autocomplete
      className={className || 'col-span-8'}
      // label={InstanceSchema.billingCodes.code.label}
      label={label}
      name="recordId"
      onChange={onSelect}
      value={value}
      errors={error}
      onChangeSearch={onChangeSearch}
      options={options}
      onEmptyOptions={onEmptyOptions}
      serverSide
      fetchNextPage={fetchNextPage}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
      limit={1}
      searchTerm={search}
      // placeholder="Type to search..."
      initialDisplayValue={value ? 'Loading...' : 'Type to search...'}
      noneText="Type to search..."
      searchRef={searchRef}
      buttonRef={buttonRef}
      hideEndOfList={true}
    />
  );
};

export default DatabaseAutocomplete;
